// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Em-z","innerTile":"Fm-z","heading":"Gm-z","instaTileBtn":"Hm-z","disabled":"Im-z","instaTileElement":"Jm-z","instagramPic":"Km-z"};